import { render, staticRenderFns } from "./DadosUsuario.vue?vue&type=template&id=efc8fbce&scoped=true"
import script from "./DadosUsuario.vue?vue&type=script&lang=js"
export * from "./DadosUsuario.vue?vue&type=script&lang=js"
import style0 from "./DadosUsuario.vue?vue&type=style&index=0&id=efc8fbce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc8fbce",
  null
  
)

export default component.exports